import { apiService } from "../../../core/api";
import { API_ENDPOINTS } from "../../../core/constants/endpoints";
import {
  CallsApiResponse,
  CallResponse,
  CallFilters,
  CallResponseType,
  CreateIdeaPayload,
  CommentsApiResponse,
  CreateCommentPayload,
  CallGoalsApiResponse,
  CallGeneralDataApiResponse,
} from "../model/types";

export class CallsService {
  async getAllCalls(filters?: CallFilters): Promise<CallsApiResponse> {
    const params = new URLSearchParams();

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.append(key, String(value));
        }
      });
    }
    // console.log("This is from Service", filters);

    const queryString = params.toString();
    const url = queryString
      ? `${API_ENDPOINTS.CALLS.GET_ALL}?${queryString}`
      : API_ENDPOINTS.CALLS.GET_ALL;

    return apiService.get<CallsApiResponse>(url);
  }

  async getCallById(id: string): Promise<CallResponse> {
    const response = await apiService.get<CallResponseType>(
      API_ENDPOINTS.CALLS.GET_BY_ID(id),
    );
    return response.data;
  }

  async callAction(
    id: string,
    actionType: "interest" | "bookmark",
    action: "add" | "remove",
  ): Promise<CallResponse> {
    // console.log("callAction called:", { id, actionType, action });
    const response = await apiService.post<any>(API_ENDPOINTS.CALLS.ACTION, {
      call_id: id,
      action_type: actionType,
      action_mode: action,
    });
    // console.log("callAction raw response:", response);
    // console.log("callAction response.data:", response.data);
    return response.data;
  }
  async followAction(
    follow_uid: string,
    action_mode: "add",
  ): Promise<CallResponse> {
    const response = await apiService.post<any>(API_ENDPOINTS.USER.FOLLOW, {
      follow_uid: follow_uid,
      action_mode: action_mode,
    });
    return response.data;
  }

  async createIdea(payload: CreateIdeaPayload): Promise<any> {
    const response = await apiService.post<any>(
      API_ENDPOINTS.IDEAS.CREATE,
      payload,
    );
    return response.data;
  }

  async getCallComments(callId: string): Promise<CommentsApiResponse> {
    return apiService.get<CommentsApiResponse>(
      API_ENDPOINTS.COMMENTS.GET_CALL_COMMENTS(callId),
    );
  }

  async createComment(payload: CreateCommentPayload): Promise<any> {
    const response = await apiService.post<any>(
      API_ENDPOINTS.COMMENTS.CREATE_CALL_COMMENT,
      payload,
    );
    return response.data;
  }

  async getDeclaredInterestCalls(
    filters?: CallFilters,
  ): Promise<CallsApiResponse> {
    const params = new URLSearchParams();

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.append(key, String(value));
        }
      });
    }

    const queryString = params.toString();
    const url = queryString
      ? `${API_ENDPOINTS.CALLS.DECLARED_INTEREST}?${queryString}`
      : API_ENDPOINTS.CALLS.DECLARED_INTEREST;

    return apiService.get<CallsApiResponse>(url);
  }

  async getBookmarkedCalls(filters?: CallFilters): Promise<CallsApiResponse> {
    const params = new URLSearchParams();

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.append(key, String(value));
        }
      });
    }

    const queryString = params.toString();
    const url = queryString
      ? `${API_ENDPOINTS.CALLS.BOOKMARKED}?${queryString}`
      : API_ENDPOINTS.CALLS.BOOKMARKED;

    return apiService.get<CallsApiResponse>(url);
  }

  async getArchivedCalls(filters?: CallFilters): Promise<CallsApiResponse> {
    const params = new URLSearchParams();

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.append(key, String(value));
        }
      });
    }

    const queryString = params.toString();
    const url = queryString
      ? `${API_ENDPOINTS.CALLS.ARCHIVED}?${queryString}`
      : API_ENDPOINTS.CALLS.ARCHIVED;

    return apiService.get<CallsApiResponse>(url);
  }

  async getCallGoals(callId: string): Promise<CallGoalsApiResponse> {
    return apiService.get<CallGoalsApiResponse>(
      API_ENDPOINTS.GOALS.GET_CALL_GOALS(callId),
    );
  }

  async exportCall(callId: string): Promise<Blob> {
    return apiService.getBlob(API_ENDPOINTS.CALLS.EXPORT_CALL(callId));
  }
  async exportGoalCalls(goalId: string): Promise<Blob> {
    return apiService.getBlob(API_ENDPOINTS.GOALS.EXPORT(goalId));
  }
  async exportCalls(): Promise<Blob> {
    return apiService.getBlob(API_ENDPOINTS.CALLS.EXPORT_CALLS);
  }

  async getCallGeneralData(): Promise<CallGeneralDataApiResponse> {
    return apiService.get<CallGeneralDataApiResponse>(
      API_ENDPOINTS.CALLS.GET_GENERAL_DATA,
    );
  }
}

export const callsService = new CallsService();
